import React, { useEffect, useState, useCallback } from "react";
import MessageHeader from "./header";
import MessageBody from "./body";
import MessageFooter from "./footer";
import MessageReply from "./reply";
import "./index.scss";
import {
  getViewMessage,
  setAxiosDefaults,
  unsubscribe,
  resubscribe,
} from "../../api/api";
import Unsubscribe from "../../components/subscribe";
import Resubscribe from "../../components/subscribe/resubscribe";
import { ToastContainer, toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import ErrorPage from "../errorPage";

const innerHeight = window.innerHeight;
export default function Message() {
  const conversationId = new URLSearchParams(window.location.search).get(
    "content_id"
  );
  const [pageName, setPageName] = useState("message");
  const token = new URLSearchParams(window.location.search).get("token");
  const [errorPage, setErrorPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    id: "",
    created_at: "",
    operator: {
      email: "",
      avatar: "",
      nickname: "",
    },
    title: "",
    like_status: 0,
    content: "",
  });
  async function getData(conversationId) {
    try {
      let { data } = await getViewMessage(conversationId);
      setData(data);
    } catch (error) {
      setErrorPage(true);
      notify("خطا در دریافت اطلاعات");
    } finally {
      setLoading(false);
    }
  }
  function notify(t) {
    toast(t, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      bodyClassName: "toast-body",
    });
  }
  useEffect(() => {
    setAxiosDefaults(token);
  }, [token]);

  const startGetData = useCallback(getData, []);
  const setLike = (i) => {
    let current = { ...data };
    current.like_status = i;
    setData(current);
  };
  useEffect(() => {
    startGetData(conversationId);
  }, [conversationId, startGetData]);

  if (pageName === "resubscribe") return <Resubscribe />;
  if (pageName === "unsubscribe")
    return (
      <Unsubscribe
        showResubscribePage={() => {
          resubscribe({ conversation_id: conversationId, token });
          setPageName("resubscribe");
        }}
      />
    );
  if (errorPage) return <ErrorPage />;
  if (pageName === "message")
    return (
      <div className="page-message">
        {loading ? (
          <div className="container p-3">
            <Skeleton height={60} className="mb-2" />
            <Skeleton width={50} height={20} className="mb-2" />
            <Skeleton height={innerHeight - 240} className="mb-2" />
            <Skeleton height={80} className="mb-2" />
          </div>
        ) : (
          <>
            <MessageHeader
              operator={data.operator}
              created_at={data.created_at}
            />
            <div style={{ minHeight: "calc(100vh - 202px)" }}>
              <MessageBody content={data.content} title={data.title} />
              <MessageReply
                id={data.id}
                set={setLike}
                likeStatus={data.like_status}
              />
            </div>

            <MessageFooter
              showUnsubscribePage={() => {
                unsubscribe({ conversation_id: conversationId, token });
                setPageName("unsubscribe");
              }}
            />
            <ToastContainer />
          </>
        )}
      </div>
    );
}
